// extracted by mini-css-extract-plugin
module.exports = {"status":"Servers_status__36-IB","offline":"Servers_offline__2S1n5","online":"Servers_online__1cbCr"};